import axios from 'axios';
import { useContext, useEffect } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface RegisterCollaborationRequest {
    invoiceId: string;
}

interface UnregisterCollaborationRequest {
    invoiceId: string;
}

const registerCollaboration = async (invoiceId: string, sessionId: string): Promise<void> => {
    await axios.post(
        `${API_URL}/invoice/collaborate/register-user`,
        { invoiceId } satisfies RegisterCollaborationRequest,
        {
            headers: {
                Authorization: sessionId,
            },
            validateStatus: (status) => status === 200 || status === 201,
        },
    );
};

const unregisterCollaboration = async (invoiceId: string, sessionId: string): Promise<void> => {
    await axios.delete(`${API_URL}/invoice/collaborate/unregister-user`, {
        headers: {
            Authorization: sessionId,
        },
        data: { invoiceId } satisfies UnregisterCollaborationRequest,
        validateStatus: (status) => status === 204,
    });
};

export const useInvoiceCollaboration = (invoiceId: string | undefined) => {
    const sessionContext = useContext(SessionContext);
    const sessionId = sessionContext?.sessionId ?? null;

    useEffect(() => {
        if (!invoiceId || !sessionId) {
            return;
        }

        const activeInvoiceId = invoiceId;
        const activeSessionId = sessionId;

        registerCollaboration(activeInvoiceId, activeSessionId).catch(() => {});

        return () => {
            unregisterCollaboration(activeInvoiceId, activeSessionId).catch(() => {});
        };
    }, [invoiceId, sessionId]);
};
